import { getLocalAccessToken, removeLocalAccessToken } from './tokenService';

let appContext;

export const injectContext = (context) => {
  appContext = context;
};

const requestInterceptor = (config) => {
  const token = getLocalAccessToken();
  const newConfig = {
    ...config
  };

  if (token) {
    newConfig.headers.Authorization = `Bearer ${token}`;
    newConfig.headers['Content-Type'] = 'application/json';
  }

  return newConfig;
};

const expiredLogout = () => {
  if (appContext) appContext.handleLogout();
  removeLocalAccessToken();
};

export const apiInterceptors = (instance) => {
  instance.interceptors.request.use(requestInterceptor, (error) => Promise.reject(error));

  instance.interceptors.response.use(
    (res) => res,
    async (err) => {
      const errorAfter = err.response;

      if (err.response) {
        const errorData = err.response.data;

        errorAfter.message =
          errorData?.message || errorData?.errorMessage || errorData?.Message || undefined;

        // Access Token expired
        if (err.response.status === 401) {
          expiredLogout();
        }
      }

      return Promise.reject(errorAfter);
    }
  );
};
